import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@chakra-ui/react'
import truncate from 'lodash/truncate'

const CarouselTitle = ({ data, theme, dataTestId }) => {
  return (
    <Heading
      as='h2'
      color={theme.textColor}
      fontFamily='heading'
      fontSize={`${theme.titleFontSize}em` || 'heading'}
      fontWeight={theme.titleFontWeight || 'heading'}
      wordBreak='break-word'
      data-testid={dataTestId}
    >
      {truncate(data.title, { length: theme.titleLength || 50 })}
    </Heading>
  )
}

CarouselTitle.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default CarouselTitle
